import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
import { CircleIcon } from 'lucide-vue-next';
import { cn } from 'Components/primitives/utils';
import { useValidation } from 'Components/inputs/useValidation';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnRadioGroupItem',
    props: /*@__PURE__*/ _mergeModels({
        value: { type: null, required: false, default: undefined },
        label: { type: String, required: false, default: undefined },
        isDisabled: { type: Boolean, required: false, default: false },
        disabled: { type: Boolean, required: false, default: false },
        staticId: { type: [String, Number, null], required: false, default: null },
        id: { type: String, required: false, default: undefined },
        name: { type: String, required: false, default: undefined },
        rules: { type: Array, required: false, default: undefined },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    }, {
        "modelValue": { type: null, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['input', 'change'], ["update:modelValue"]),
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        /**
         * The checked state or selected value. Use with `v-model`.
         */
        const model = _useModel(__props, "modelValue");
        const emit = __emit;
        const isChecked = computed(() => {
            if (props.value !== undefined) {
                return model.value === props.value;
            }
            return Boolean(model.value);
        });
        const isDirty = ref(false);
        const { errorMessage, onBlur: onValidationBlur, } = useValidation(isDirty, props, model);
        function onClick() {
            if (props.isDisabled || props.disabled)
                return;
            const next = props.value !== undefined ? props.value : true;
            model.value = next;
            emit('input', next);
            emit('change', next);
            isDirty.value = true;
        }
        function onBlur() {
            isDirty.value = true;
            onValidationBlur();
        }
        const __returned__ = { props, model, emit, isChecked, isDirty, errorMessage, onValidationBlur, onClick, onBlur, get CircleIcon() { return CircleIcon; }, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
